import React from 'react';
import './StandardCreditCardOffer.scss';
import { Button } from 'components/form/Button';
import { InfoCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { DEFAULT_TC_TEXT, isApplyToConfidence } from 'helpers/offer.helpers';
import { CSTooltip } from 'components/Tooltip/CSToolTip';
import { formatIncomeWithNegatives } from 'helpers/common';
import { ReactComponent as OpenInNew } from 'style/_assets/icons/open-in-new.svg';
import Label from 'components/form/Label/Label';
import { Image } from 'components/Image/Image';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { CreditCardPreApprovedMessage } from 'components/Fragments/CreditCardPreApprovedMessage/CreditCardPreApprovedMessage';
import BonusText from '../fragments/BonusText/BonusText';
import { Tag } from 'components/Tag';
import AnnualFee from './AnnualFee';
import MinimunDeposit from './MinimunDeposit';
import RegularAPR from './RegularAPR';
import { formatIncome } from 'helpers/money.helper';
import { CREDIT_CARD_VERTICAL } from 'types/marketplaceTiles.constants';
import ApprovalOddsBadge from 'components/Offers/fragments/ApprovalOddsBadge';
import SesameGuarantee from 'components/Offers/fragments/SesameGuarantee';
import ReviewsRating from 'components/Offers/fragments/ReviewsRating';
import { GUARANTEE } from 'helpers/approvalOdds.helper';
import { Link } from 'components/navigation/Link/Link';
import { useConfig } from 'hook/config.hook';
import OfferHeader from '../OfferHeader/OfferHeader';
import AmexWithConfidence from '../AmexWithConfidence/AmexWithConfidence';

const BodyContainer = ({
  containerType,
  datatestid,
  bodyContentType,
  hideNAFields,
  minimunDeposit,
  ...props
}) => {
  const {
    introBtOverrideText,
    introPurchaseOverrideText,
    rewardsBonusTextShort,
    rewardsBonusTextLong,
    signupBonusTextShort,
    signupBonusTextLong,
    aprDetails,
    annualFeeDetails,
    btText,
  } = props.offerMetadata;

  const showMinimunDepositLabel = minimunDeposit?.minimunDeposit;
  const getIntroBalance = () => {
    return introBtOverrideText ? introBtOverrideText : 'N/A';
  };
  const getIntroPurchase = () => {
    return introPurchaseOverrideText ? introPurchaseOverrideText : 'N/A';
  };
  const getBalanceTransferFee = () => {
    return btText ?? 'N/A';
  };

  const hideIntroBalanceAprNA = hideNAFields && getIntroBalance() === 'N/A';
  const hideIntroPurchaseAprNA = hideNAFields && getIntroPurchase() === 'N/A';
  if (
    containerType === 'SUGGESTED_BEST_CARDS' ||
    bodyContentType === 'BALANCE_TRANSFER'
  ) {
    return (
      <div className="highlighted-card-attributes">
        <div className="cardAttributes__block introPurchaseBlock">
          {!hideIntroBalanceAprNA && (
            <>
              <div className="cardAttributes__blockTitle introPurchaseBlockTitle">
                Intro Balance Transfer APR
              </div>
              <div className="cardAttributes__blockContent introPurchase">
                {getIntroBalance()}
              </div>
            </>
          )}
          <div className="margT14"></div>
          {!hideIntroPurchaseAprNA && (
            <>
              <div className="cardAttributes__blockTitle introBalanceBlockTitle">
                Intro Purchase APR
              </div>
              <div className="cardAttributes__blockContent introBalance">
                {getIntroPurchase()}
              </div>
            </>
          )}
        </div>
        <RegularAPR datatestid={datatestid} aprDetails={aprDetails} />
        <div className="cardAttributes__block introPurchaseBlock introBalanceBlock">
          <div className="cardAttributes__blockTitle introBalanceBlockTitle">
            Balance Transfer Fee
          </div>
          <div className="cardAttributes__blockContent introBalance">
            {getBalanceTransferFee()}
          </div>
        </div>
        <AnnualFee
          datatestid={datatestid}
          annualFeeDetails={annualFeeDetails}
        />
      </div>
    );
  } else if (
    containerType === 'SUGGESTED_REWARDS_CARDS' ||
    bodyContentType === 'REWARDS' ||
    bodyContentType === 'CASH_BACK'
  ) {
    return (
      <div className="highlighted-card-attributes">
        <BonusText
          type={'Rewards'}
          bonusTextShort={rewardsBonusTextShort}
          bonusTextLong={rewardsBonusTextLong}
          outerClass={'cardAttributes__blockTitle'}
          innerTextClass={'cardAttributes__blockContent'}
          tooltipIcon={InfoCircleOutlined}
        />
        <BonusText
          type={'Bonus Offer'}
          bonusTextShort={signupBonusTextShort}
          bonusTextLong={signupBonusTextLong}
          outerClass={'cardAttributes__blockTitle'}
          innerTextClass={'cardAttributes__blockContent'}
          tooltipIcon={InfoCircleOutlined}
        />

        <RegularAPR datatestid={datatestid} aprDetails={aprDetails} />
        <AnnualFee
          datatestid={datatestid}
          annualFeeDetails={annualFeeDetails}
        />
      </div>
    );
  } else if (
    containerType === 'SUGGESTED_BALANCE_TRANSFER_CARDS' ||
    bodyContentType === 'BALANCE_TRANSFER'
  ) {
    return (
      <div className="highlighted-card-attributes">
        {!hideIntroBalanceAprNA && (
          <div className="cardAttributes__block introPurchaseBlock introPurchaseBlock">
            <div className="cardAttributes__blockTitle introPurchaseBlockTitle">
              Intro Balance Transfer APR
            </div>
            <div className="cardAttributes__blockContent introPurchase">
              {getIntroBalance()}
            </div>
          </div>
        )}
        {!hideIntroPurchaseAprNA && (
          <div className="cardAttributes__block introPurchaseBlock introBalanceBlock">
            <div className="cardAttributes__blockTitle introBalanceBlockTitle">
              Intro Purchase APR
            </div>
            <div className="cardAttributes__blockContent introBalance">
              {getIntroPurchase()}
            </div>
          </div>
        )}

        <RegularAPR datatestid={datatestid} aprDetails={aprDetails} />
        <AnnualFee
          datatestid={datatestid}
          annualFeeDetails={annualFeeDetails}
        />
      </div>
    );
  } else {
    return (
      <div className="highlighted-card-attributes">
        <RegularAPR datatestid={datatestid} aprDetails={aprDetails} />
        <AnnualFee
          datatestid={datatestid}
          annualFeeDetails={annualFeeDetails}
        />
        {showMinimunDepositLabel && (
          <MinimunDeposit
            minimunDepositDetails={minimunDeposit?.minimunDeposit}
          />
        )}
      </div>
    );
  }
};

const predictedLimitContainerClass = 'predictedLimit';

export function PredictedCreditLimit({
  predictedCreditLimit,
  tooltipPlacement,
  datatestid,
}) {
  const { config } = useConfig();
  return (
    <div
      className={predictedLimitContainerClass}
      data-testid={datatestid ? `${datatestid}-predictedCreditLimit` : null}
    >
      <CSTooltip
        vertical={CREDIT_CARD_VERTICAL}
        title={config?.disclaimers?.predictedCreditLimitTooltip}
        isInline={true}
        placement={tooltipPlacement ? tooltipPlacement : null}
        className="predictedLimit__tooltipContainer"
        datatestid={datatestid ? `${datatestid}-tooltip` : null}
        tooltipName={'Predicted Credit Limit Tooltip'}
      >
        <span className="system_neutral_n250_text">You may access up to</span>
        <span className="fontGray400">
          {`${' '}${
            predictedCreditLimit
              ? formatIncome(predictedCreditLimit)
              : formatIncome(300)
          }`}{' '}
        </span>
        <QuestionCircleOutlined
          className="fontGray300"
          style={{ display: 'inline-block', position: 'relative', top: -3 }}
        />
      </CSTooltip>
    </div>
  );
}

export function CreditSavings({ creditSavings, datatestid }) {
  const { config } = useConfig();
  return (
    <div
      className="creditSavings"
      data-testid={datatestid ? `${datatestid}-creditSavings` : null}
    >
      <CSTooltip
        vertical={CREDIT_CARD_VERTICAL}
        title={config?.disclaimers?.creditSavingsTooltip}
        isInline={true}
        overlayClassName="whiteTooltip"
        datatestid={datatestid ? `${datatestid}-tooltip` : null}
      >
        {`Potential annual savings ${
          creditSavings
            ? formatIncomeWithNegatives(creditSavings)
            : formatIncome(100)
        }`}{' '}
        <QuestionCircleOutlined
          style={{ display: 'inline-block', position: 'relative', top: -2 }}
        />
      </CSTooltip>
    </div>
  );
}

function CardName({
  name,
  datatestid,
  clickDetailsHandler,
  onMouseEnter,
  onMouseLeave,
}) {
  return (
    <>
      <Label
        type="Subtitle-2"
        color="secondary_text_light"
        className=" otherLink margB20"
        onClick={clickDetailsHandler}
        datatestid={datatestid ? `${datatestid}-value` : null}
        dangerouslySetInnerHTML={{
          __html: name,
        }}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    </>
  );
}

function CardImage({ imageLink, datatestid, onClick, children }) {
  return (
    <div className="cardImageContainer">
      <img
        data-testid={datatestid ? `${datatestid}-value` : null}
        alt="credit card"
        onClick={onClick}
        src={imageLink}
        className="cardImage pointer"
      ></img>
      {children}
    </div>
  );
}

function CardRatingAndOdds(props) {
  const { clickReviewHandler, offerMetadata, config, showApprovalOddsBadge } =
    props;
  return (
    <FlexContainer className="cardRatingAndOddsContainer">
      {config?.showCreditCardReview && (
        <ReviewsRating
          offerMetadata={offerMetadata}
          containerCustomClass={'cardRatingContainer pointer'}
          labelCustomClass={'fontNeutral300 text-12 margt2 m-text-left'}
          badgeCustomClass={'pointer margt6'}
          onClick={clickReviewHandler}
        />
      )}
      {!showApprovalOddsBadge && (
        <ApprovalOddsBadge
          offerMetadata={offerMetadata}
          labelCustomClass={'fontNeutral300 text-12 margt2 m-text-right'}
          badgeCustomClass={'margT2'}
          isTooltipSorrounded
          isRedesignCard
          tipOverlayClassName={'creditOddsTipOverlay'}
        />
      )}
    </FlexContainer>
  );
}

const ApplyNowButton = props => {
  const { datatestid, clickApplyHandler, loading, buttonLabel } = props;

  return (
    <>
      <Button
        className="applyNowButton"
        mrphType="primary"
        data-testid={datatestid ? `${datatestid}-label` : null}
        onClick={clickApplyHandler}
        loading={loading}
        role="presentation"
      >
        <Label
          datatestid={`${datatestid}-applyNowText`}
          type="Subtitle-2"
          color="primary_cta_text_light"
          className="flex-container justify-center align-items-center"
          tabIndex="-1"
        >
          <Image imgClass={'standardLockIcon'} />
          {buttonLabel}
        </Label>
      </Button>
    </>
  );
};

function ViewDetails({ datatestid, clickDetailsHandler }) {
  return (
    <div className="moreInfo">
      <div
        onClick={clickDetailsHandler}
        data-testid={datatestid ? `${datatestid}-details` : null}
      >
        <Label type="Subtitle-2 link">View more details</Label>
      </div>
    </div>
  );
}

function StandardCreditCardOfferDesktop({
  datatestid,
  offerMetadata,
  offerImageLinkUrlProxy,
  clickApplyHandler,
  cardUiModuleConfiguration,
  clickPrequalificationHandler,
  clickDetailsHandler,
  clickReviewHandler,
  clickApplyCardNameHandler,
  clickApplyImageHandler,
  clickTcHandler,
  bodyContentType,
  containerType,
  hideNAFields,
  seenPixel,
  showApplyNow,
  loading,
  prequalModalType,
  classNameOverwrite,
  buttonLabel,
  hideCreditLimitByConfig,
  minimunDeposit,
  reviewRating,
  goToViewProgramTerms,
  isPreScreen,
  showApprovalOddsBadge,
  ...props
}) {
  const {
    tcUrl,
    tcText,
    name,
    issuer,
    hideCreditLimit,
    predictedCreditLimit,
    applyNowLabelFlag,
    applyNowLabelText,
    badgeEnabledFlag,
    badgeLabel,
    productKey,
    observedApprovalOdds,
    prePopulatedTooltipText,
  } = offerMetadata;

  const showAmexWithConfidence = isApplyToConfidence(productKey);
  const showBadge = badgeEnabledFlag && badgeLabel;

  return (
    <OfferHeader
      isPreScreen={isPreScreen}
      hideClass="m-hide t-hide"
      cardUiModuleConfiguration={cardUiModuleConfiguration}
    >
      <div className={`m-hide t-hide `}>
        <div
          data-testid={datatestid + '-desktop'}
          className={`${
            classNameOverwrite ? classNameOverwrite.ccOfferContainer : ``
          } CreditCardOfferModule desktop`}
        >
          {showAmexWithConfidence && (
            <AmexWithConfidence showmarketPlaceViewAmex={true} />
          )}

          <div className="topSection">
            {!hideCreditLimit &&
            !hideCreditLimitByConfig &&
            !prequalModalType ? (
              <PredictedCreditLimit
                predictedCreditLimit={predictedCreditLimit}
                datatestid={datatestid}
              />
            ) : (
              <div className={predictedLimitContainerClass} />
            )}
            {seenPixel}
            {prequalModalType && (
              <CardName
                name={name}
                clickDetailsHandler={clickApplyCardNameHandler}
                datatestid={datatestid ? `${datatestid}-cardName` : null}
              />
            )}
            <div className="cardInfo">
              <CardImage
                datatestid={datatestid ? `${datatestid}-cardImage` : null}
                imageLink={offerImageLinkUrlProxy}
                onClick={clickApplyImageHandler}
              >
                {tcUrl && (
                  <a
                    className="tcBlock"
                    onClick={clickTcHandler}
                    href={tcUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <>
                      <span className="tcText link-style no-line">
                        {tcText || DEFAULT_TC_TEXT}
                      </span>
                      <OpenInNew height="16" width="16" />
                    </>
                  </a>
                )}
              </CardImage>

              <FlexContainer className="flex-column item-container">
                <FlexContainer className="format100">
                  <FlexContainer className="card__infoContent">
                    {showBadge && (
                      <Tag
                        datatestid={
                          datatestid ? `${datatestid}-offerBadge` : null
                        }
                        extClass="offerTag margtb8"
                      >
                        {badgeLabel}
                      </Tag>
                    )}

                    {!prequalModalType && (
                      <CardName
                        name={name}
                        clickDetailsHandler={clickApplyCardNameHandler}
                        datatestid={
                          datatestid ? `${datatestid}-cardName` : null
                        }
                      />
                    )}

                    <CardRatingAndOdds
                      clickReviewHandler={clickReviewHandler}
                      pagePosition={props.pagePosition}
                      datatestid={
                        datatestid ? `${datatestid}-cardRatingAndOdds` : null
                      }
                      offerMetadata={offerMetadata}
                      config={props?.config}
                      showApprovalOddsBadge={showApprovalOddsBadge}
                    />
                  </FlexContainer>
                  <FlexContainer className="flex-column cardApplyAreaContainer justify-center items-align-center margL24 margB12">
                    <CreditCardPreApprovedMessage
                      className={'appPrePopulatedWaring mobile-justify-center'}
                      prePopulatedTooltipText={prePopulatedTooltipText}
                      role="presentation"
                    />
                    {showApplyNow && (
                      <ApplyNowButton
                        datatestid={
                          datatestid ? `${datatestid}-cardApplyButton` : null
                        }
                        issuer={issuer}
                        productKey={productKey}
                        name={name}
                        clickApplyHandler={clickApplyHandler}
                        applyNowLabelFlag={applyNowLabelFlag}
                        applyNowLabelText={applyNowLabelText}
                        loading={loading}
                        buttonLabel={buttonLabel}
                      />
                    )}
                  </FlexContainer>
                </FlexContainer>
                {observedApprovalOdds === GUARANTEE && (
                  <SesameGuarantee
                    customClass={'align-self-start margl24 margt20 text-13'}
                    goToViewProgramTerms={goToViewProgramTerms}
                  />
                )}
              </FlexContainer>
            </div>
          </div>
          <div className="bottomSection">
            <BodyContainer
              offerMetadata={offerMetadata}
              containerType={containerType}
              bodyContentType={bodyContentType}
              hideNAFields={hideNAFields}
              minimunDeposit={minimunDeposit}
              datatestid={datatestid ? `${datatestid}-cardRates-apr2` : null}
            />

            <ViewDetails
              datatestid={datatestid ? `${datatestid}-viewDetails` : null}
              clickDetailsHandler={clickDetailsHandler}
              tcUrl={'View more details'}
            />
          </div>
        </div>
      </div>
    </OfferHeader>
  );
}

function StandardCreditCardOfferMobile({
  datatestid,
  offerMetadata,
  offerImageLinkUrlProxy,
  clickPrequalificationHandler,
  clickApplyHandler,
  cardUiModuleConfiguration,
  clickApplyImageHandler,
  clickApplyCardNameHandler,
  clickDetailsHandler,
  clickReviewHandler,
  clickTcHandler,
  bodyContentType,
  containerType,
  hideNAFields,
  seenPixel,
  showApplyNow,
  loading,
  classNameOverwrite,
  buttonLabel,
  hideCreditLimitByConfig,
  minimunDeposit,
  reviewRating,
  goToViewProgramTerms,
  isPreScreen,
  ...props
}) {
  const {
    tcUrl,
    tcText,
    name,
    issuer,
    hideCreditLimit,
    predictedCreditLimit,
    applyNowLabelFlag,
    applyNowLabelText,
    preApproved,
    preApprovalTooltipText,
    badgeEnabledFlag,
    badgeLabel,
    productKey,
    observedApprovalOdds,
    prePopulatedTooltipText,
  } = offerMetadata;

  const showBadge = badgeEnabledFlag && badgeLabel;

  return (
    <OfferHeader
      isPreScreen={isPreScreen}
      hideClass="d-hide"
      cardUiModuleConfiguration={cardUiModuleConfiguration}
    >
      <div className={`d-hide ${isPreScreen ? 'border-rad8px' : ''}`}>
        <div
          data-testid={datatestid + '-mobile'}
          className={`${
            classNameOverwrite ? classNameOverwrite.ccOfferContainer : ``
          } CreditCardOfferModule mobile`}
        >
          {!hideCreditLimit && !hideCreditLimitByConfig ? (
            <PredictedCreditLimit
              predictedCreditLimit={predictedCreditLimit}
              datatestid={datatestid}
            />
          ) : (
            <div className={predictedLimitContainerClass}>&nbsp;</div>
          )}
          {seenPixel}
          <CardImage
            datatestid={datatestid ? `${datatestid}-cardImage` : null}
            imageLink={offerImageLinkUrlProxy}
            onClick={clickApplyImageHandler}
          />
          <CardName
            datatestid={datatestid ? `${datatestid}-cardName` : null}
            clickDetailsHandler={clickApplyCardNameHandler}
            name={name}
          />
          {showBadge && (
            <FlexContainer
              datatestid={datatestid ? `${datatestid}-offerBadge` : null}
              className="justify-between items-align-center margB20"
            >
              <Tag
                datatestid={datatestid ? `${datatestid}-offerBadge` : null}
                extClass="offerTag"
              >
                {badgeLabel}
              </Tag>
              {tcUrl && (
                <Link
                  className="text-12 link-style no-line"
                  onClickCallback={clickTcHandler}
                >
                  {tcText || DEFAULT_TC_TEXT}
                </Link>
              )}
            </FlexContainer>
          )}
          <CardRatingAndOdds
            productKey={productKey}
            preApproved={preApproved}
            preApprovalTooltipText={preApprovalTooltipText}
            reviewRating={reviewRating}
            datatestid={datatestid ? `${datatestid}-cardRatingAndOdds` : null}
            clickReviewHandler={clickReviewHandler}
            pagePosition={props.pagePosition}
            offerMetadata={offerMetadata}
            config={props.config}
          />
          <BodyContainer
            offerMetadata={offerMetadata}
            containerType={containerType}
            bodyContentType={bodyContentType}
            datatestid={datatestid}
            hideNAFields={hideNAFields}
            minimunDeposit={minimunDeposit}
          />
          {!showBadge && (
            <Link className="tcBlock margT4" onClickCallback={clickTcHandler}>
              {tcUrl && (
                <>
                  <span className="tcText link-style no-line">
                    {tcText || DEFAULT_TC_TEXT}
                  </span>
                  <OpenInNew height="16" width="16" />
                </>
              )}
            </Link>
          )}
          <div className="margB24" />
          {/* <APR
        datatestid={datatestid ? `${datatestid}-cardRates` : null}
        introPurchaseAprFlag={introPurchaseAprFlag}
        introBtApr={introBtApr}
        aprDetails={aprDetails}
        apr={apr}
        annualFeeDetails={annualFeeDetails}
        introPurchaseApr={introPurchaseApr}
      /> */}
          <FlexContainer className="card__applySection flex-column m-items-align-center ">
            <CreditCardPreApprovedMessage
              prePopulatedTooltipText={prePopulatedTooltipText}
              className={'appPrePopulatedWaring mobile-justify-center'}
              role="presentation"
            />
            {observedApprovalOdds === GUARANTEE && (
              <SesameGuarantee goToViewProgramTerms={goToViewProgramTerms} />
            )}
            {showApplyNow && (
              <ApplyNowButton
                name={name}
                datatestid={datatestid ? `${datatestid}-cardApplyButton` : null}
                issuer={issuer}
                productKey={productKey}
                clickApplyHandler={clickApplyHandler}
                applyNowLabelFlag={applyNowLabelFlag}
                applyNowLabelText={applyNowLabelText}
                buttonLabel={buttonLabel}
                loading={loading}
              />
            )}
            <ViewDetails
              clickDetailsHandler={clickDetailsHandler}
              datatestid={datatestid ? `${datatestid}-viewDetails` : null}
            />
          </FlexContainer>
        </div>
      </div>
    </OfferHeader>
  );
}

const StandardCreditCardOffer = props => {
  let datatestid = props.datatestid;

  if (datatestid === null || datatestid === undefined) {
    datatestid = '';
  }

  const { offerMetadata } = props;

  const isPreScreen = offerMetadata?.experienceName === 'PRE_SCREENED';

  return (
    <>
      <StandardCreditCardOfferDesktop
        {...props}
        datatestid={`${datatestid}-desktop`}
        isPreScreen={isPreScreen}
      />
      <StandardCreditCardOfferMobile
        {...props}
        datatestid={`${datatestid}-mobile`}
        isPreScreen={isPreScreen}
      />
    </>
  );
};

export {
  StandardCreditCardOffer,
  StandardCreditCardOfferMobile,
  StandardCreditCardOfferDesktop,
};
